import { connect } from 'react-redux';
import React, { Component } from 'react';

import {http_methods} from '../utils';
import {default_policy, prepare, submit} from '../request_client';

import md from 'markdown-it';
import md_checkbox from 'markdown-it-checkbox';
import markdown_style from 'github-markdown-css';

import {resolve_refs, strip_props, spec_validator} from '../spec_utils';
import yaml from 'js-yaml';

import MethodBadge from './MethodBadge';
import TagBadge from './TagBadge';
import SplitPanel from './SplitPanel';
import Pane from './Pane';
import DocView from './DocView';
import {Card, CardActions, CardHeader, CardText, FlatButton, Paper, Divider, TextField, SelectField, MenuItem, Dialog} from 'material-ui';

import _ from 'lodash';
import dv from 'validator';
import MethodsNode from './MethodsNode';

const SpecNode = props => {
  const {
    path,
    spec,
    node,
    route
  } = props;

  let {
    path_params = {},
    tags = [],
    policy = {}
  } = props;

  const markdown = new md();
  if (!_.isObject(node)) {
    return null;
  }
  const keys = Object.keys(node);
  if (keys.length === 0) {
    return null;
  }

  tags = _.union(tags, node.tags);
  policy = _.defaultsDeep({}, node.policy, policy);

  const this_param = node.param;
  if (this_param) {
    const name = path[path.length - 1].substr(2);
    path_params = _.merge({}, path_params, {[name]: this_param});
  }

  return <div>
    {keys.map(key => {
      if (key === 'methods') return <MethodsNode key={key} spec={spec} node={node.methods} route={route} tags={tags} policy={policy} path={path} path_params={path_params}/>;

      if (!key.startsWith('/')) return null;

      return <div key={key} id={route+key}>
      <div className="api-info__head">
        <span className="api-info__head-title">{route+key}</span>
        { node[key].summary ?
          <span className="api-info__head-sub-title"> | &nbsp; {node[key].summary}</span> : ''
        }
      </div>
      { tags.length > 0 ? <div className="api-info__tags">
               {tags.map(tag => <TagBadge className='api-info__tag api-info__tag--bgcolor' tag={tag}/>)}
           </div>:null
      }
      {node[key].description && <div className="api-info__description" dangerouslySetInnerHTML={{__html:markdown.render(node[key].description)}}></div>}
      <SpecNode key={key} path={path.concat(key)} route={route+key} node={node[key]} tags={tags} policy={policy} spec={spec} path_params={path_params}/>
      </div>
    })}
  </div>
};

export default SpecNode;
